import {
  IonButtons,
  IonCard,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
} from "@ionic/react";

import { useLocation } from "react-router-dom";

import { useSelector } from "react-redux";
import { selectUser } from "../store/userAuthentication/selectors/selectUser";
import UserAvatar from "../components/UserAvatar";
import { selectAppPages } from "../store/userAuthentication/selectors/selectAppPages";
import NotificationSubscription from "../components/NotificationSubscription";
import { OrganizationSelect } from "./OrganizationSelect";

const Menu: React.FC = () => {
  const location = useLocation();
  const user = useSelector(selectUser);
  const appPages = useSelector(selectAppPages);

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonCard color="primary">
          <IonItem color="primary">
            <UserAvatar user={user}></UserAvatar>
            <IonLabel>
              <h2 style={{ fontWeight: 500 }}>{user?.name}</h2>
              <h4>{user?.email}</h4>
            </IonLabel>
            <IonButtons slot="end">
              <NotificationSubscription />
            </IonButtons>
          </IonItem>
        </IonCard>
        <IonList class="ion-padding-horizontal" color="transparent">
          <OrganizationSelect />
          {appPages
            .filter(({ menu }) => menu)
            .map((appPage, index) => (
              <IonMenuToggle key={index} auto-hide="false">
                <IonItem
                  color={location.pathname.includes(appPage.url) ? "primary" : "transparent"}
                  routerLink={appPage.url}
                  lines="none"
                  detail={false}
                  style={{
                    borderRadius: "4px",
                    marginBottom: "4px",
                  }}
                >
                  <IonIcon slot="start" icon={appPage.icon} />
                  <IonLabel>
                    {appPage.title === "Documentos" ? (
                      <h2>{appPage.title}</h2>
                    ) : (
                      <h2>{appPage.title}</h2>
                    )}
                  </IonLabel>
                </IonItem>
              </IonMenuToggle>
            ))}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
